export default __webpack_public_path__ + "static/media/Tania_WebDevelopmentLead.d83db046.jpg";